function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useContext } from 'react';
import styles from './RecordCompareRecordObject.module.scss';
import { Column } from '../Layout/RecordCompareLayout';
import RadioInput from '../../../Inputs/RadioInput/RadioInput';
import Tooltip from '../../../Tips/Tooltip/Tooltip';
import { getColumnId, getRowId } from '../../util/recordCompareAria';
import useRecordLabel from '../../hooks/useRecordCompareLabel';
import FileDownload from './RecordCompareFileDownload';
import CompareContext from './RecordCompareContext';
import RecordCompareStateContext from '../../RecordCompareStateContext';
export default function SelectColumn(_ref) {
  var recordIndex = _ref.recordIndex,
    property = _ref.property,
    checked = _ref.checked;
  var _useContext = useContext(CompareContext),
    records = _useContext.records,
    mergeRecord = _useContext.mergeRecord,
    propertyPrefix = _useContext.propertyPrefix;
  var _useContext2 = useContext(RecordCompareStateContext),
    mergeSelections = _useContext2.mergeSelections,
    setLastSelection = _useContext2.setLastSelection;
  var uiSchema = mergeRecord.uiSchema;
  var recordId = records[recordIndex].recordId;
  var selectionId = propertyPrefix + property;
  var disabled = uiSchema[property]['ui:disabled'];
  var handleChange = useCallback(function () {
    setLastSelection(recordIndex);
    mergeSelections(_defineProperty({}, selectionId, recordIndex));
  }, [setLastSelection, mergeSelections, recordIndex, selectionId]);
  var _useRecordLabel = useRecordLabel(recordIndex, property),
    label = _useRecordLabel.label,
    escape = _useRecordLabel.escape,
    isEmpty = _useRecordLabel.isEmpty,
    uri = _useRecordLabel.uri;
  return /*#__PURE__*/React.createElement(Column, {
    className: isEmpty ? styles['empty'] : '',
    highlight: checked
  }, /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: "@dm/components.record-compare.tooltips.merge-disabled-field",
    neverShow: !disabled,
    direction: "left"
  }, function (_ref2) {
    var ref = _ref2.ref,
      describedby = _ref2.describedby,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement("span", Object.assign({
      "aria-describedby": describedby,
      ref: ref
    }, events), /*#__PURE__*/React.createElement(RadioInput, {
      "aria-describedby": "".concat(getColumnId(recordIndex), " ").concat(getRowId(property)),
      checked: checked,
      disabled: false,
      readonly: disabled && !checked,
      id: "".concat(recordId, "-").concat(property, "-").concat(recordIndex),
      label: label,
      labelEscape: escape,
      name: "".concat(property),
      onChange: handleChange,
      size: "small"
    }));
  }), /*#__PURE__*/React.createElement(FileDownload, {
    uri: uri,
    label: label
  }));
}